
































































































































































import VueOptions from '@utils/VueOptions'
import ResourceBindSelector from '@ui/ResourceBindSelector/ResourceBindSelector'
import LoadingIndicator from '@/components/LoadingIndicator'
import Modal from '@/components/Modal'
import CalendarService from '@services/CalendarService'

settings =
  name: 'OnsiteSpaceAvailabilityBindSelector'

  resources:
    space_booth:
      resourceName: 'space_booth'
      slug: 'suppliers/:supplierId/space_booths/:spaceBooth.id/edit'
      fetch: false

    availabilities:
      resourceName: 'audience_availability'
      slug: 'suppliers/:supplierId/audience_availabilities'
      fetch: false

  vue:
    props: ['spaceBooth', 'options']

    components: {
      ResourceBindSelector,
      LoadingIndicator,
      Modal,
    }

    data: ->
      selectedSpaceAvailabilities: []
      selectedAvailabilities: []
      advancedSettings: []

      reachModal:
        show: false
        availabilities: []
        segment: null
        dayOptions: []
        minDuration: null
        maxDuration: null
        engagementCapacity: null

    mounted: ->
      @fetchAvailabilities()

    computed:
      creativeId: -> @$route.params.audienceCreativeId
      supplierId: -> @options?.supplierId || @$store.member.supplier.id
      disabled: -> @options?.disabled? && @options.disabled
      spaceAvailabilityIds: -> @spaceBooth.availability_ids || []
      spaceAvailabilities: ->
        items = []
        for availability in (@availabilities || [])
          items.push availability if availability.id in @spaceAvailabilityIds
        items

      segmentRenamed: -> @spaceBooth.segment_renamed || @spaceBooth.syncing_segments

      spaceAvailabilitiesTableData: ->
        for availability in @spaceAvailabilities
          id: availability.id
          data: availability
          experience: availability.title
          location: @$options.filters.formatLocation(availability)
          street: availability.venue_street
          venue: availability.venue_name

      availabilitiesTableData: ->
        for availability in (@availabilities || [])
          continue if availability.id in @spaceAvailabilityIds
          id: availability.id
          data: availability
          experience: availability.title
          location: @$options.filters.formatLocation(availability)
          street: availability.venue_street
          venue: availability.venue_name

      canSaveReachModal: ->
        return false unless @reachModal.engagementCapacity?[@reachModal.segment]
        { reach } = @reachModal.engagementCapacity?[@reachModal.segment]
        return true if reach.default.daily
        values = Object.values(reach.daily)
        !values.some((v) => !v)

      optionsForBindSelector: ->
        required: true
        title: 'Hosted at these Venues'
        # description: 'Select the venues that have this segment available to sponsors'
        addButtonText: 'Add New Venue'
        addExistingButtonText: 'Add Existing Venue'
        why: 'You can setup more venues to host this opportunity.' if @availabilitiesTableData.length

    methods:
      hiSpaceAvailabilitiesSelectionChange: (availabilities) ->
        @selectedSpaceAvailabilities = availabilities
      hiSpaceAvailabilitiesRowClick: (row) ->
        @$refs.spaceAvailabilitiesTable.toggleRowSelection row
      hiUnbindSpaceAvailability: (availability) ->
        @unbindAvailabilitiesFromSpaceTrigger [availability]
      hiUnbindSelectedSpaceAvailabilities: ->
        @unbindAvailabilitiesFromSpaceTrigger @selectedSpaceAvailabilities

      hiAvailabilitiesSelectionChange: (availabilities) ->
        @selectedAvailabilities = availabilities
      hiAvailabilitiesRowClick: (row) ->
        @$refs.availabilitiesTable.toggleRowSelection row
      hiBindAvailability: (availability) ->
        @bindAvailabilitiesToSpaceTrigger [availability]
      hiBindSelectedAvailabilities: ->
        @$refs.bindSelector.close()
        @bindAvailabilitiesToSpaceTrigger @selectedAvailabilities

      hiCloseReachModal: ->
        @closeReachModal()

      hiToggleAdvancedSettings: ->
        if '1' in @advancedSettings
          @advancedSettings = []
        else
          @advancedSettings = ['1']

      hiSaveReachModal: ->
        { availabilities, engagementCapacity, minDuration, maxDuration } = @reachModal
        @reachModal.engagementCapacity[@reachModal.segment].reach.min_duration = minDuration
        @reachModal.engagementCapacity[@reachModal.segment].reach.max_duration = maxDuration
        delete @reachModal.engagementCapacity[@reachModal.segment].minimum_purchase_in_cents if minDuration || maxDuration
        @setCapacityTrigger availabilities, engagementCapacity
        @closeReachModal()

      hiSetReach: ->
        @hiEditReach @selectedSpaceAvailabilities.map((a) => a.data)

      hiEditReach: (availabilities) ->
        availability = availabilities[0]
        { segment } = @spaceBooth
        dayOptions = CalendarService.dayOptionsForEvents availability.dates
        engagementCapacity = JSON.parse(JSON.stringify(availability.engagement_capacity))
        engagementCapacity[segment] ||= {}
        engagementCapacity[segment].reach ||= {}
        engagementCapacity[segment].reach.daily ||= {}
        engagementCapacity[segment].reach.daily[option.value] = availability.engagement_capacity[segment]?.reach?.daily?[option.value] for option in dayOptions
        engagementCapacity[segment].reach.default ||= {}
        engagementCapacity[segment].reach.default.daily ||= availability.engagement_capacity[segment]?.reach?.default?.daily
        minDuration = engagementCapacity[segment].reach.min_duration
        maxDuration = engagementCapacity[segment].reach.max_duration

        @advancedSettings = []
        @advancedSettings = ['1'] unless @isEmptyValue engagementCapacity[segment].reach.daily
        @reachModal =
          show: true
          availabilities: availabilities
          segment: segment
          dayOptions: dayOptions
          minDuration: minDuration
          maxDuration: maxDuration
          engagementCapacity: engagementCapacity

      hiChangeDailyReach: (value, day) ->
        v = parseInt value.replace(/,/g, '')
        v = undefined if isNaN v
        @reachModal.engagementCapacity[@reachModal.segment].reach.daily[day] = v

      hiChangeDefaultDailyReach: (value) ->
        v = parseInt value.replace(/,/g, '')
        v = undefined if isNaN v
        @simulatorQuantity = v
        @reachModal.engagementCapacity[@reachModal.segment].reach.default.daily = v

      closeReachModal: ->
        @reachModal =
          show: false
          data: null

      availabilityHasReach: (availability) ->
        !@isEmptyValue availability.engagement_capacity?[@spaceBooth.segment]?.reach

      formatReachModalDescription: ->
        availability = @reachModal.availabilities[0]
        location = @$options.filters.formatLocation availability
        address = [availability.venue_name, location]
        @compact(address).join(', ')

      formatReach: (availability) ->
        { reach } = availability.engagement_capacity[@spaceBooth.segment]
        values = []
        values.push ...Object.values(reach.daily || {})
        values.push ...Object.values(reach.default || {})
        values = @compact(new Float64Array(new Set(values)))
        values.sort()
        return '' unless values.length
        return values[0] unless values.length > 1
        "#{values[0]} - #{values[values.length - 1]}"

      bindAvailabilitiesToSpaceTrigger: (availabilities) ->
        payload = { availability_ids: availabilities.map((a) => a.id) }
        @triggerResource 'space_booth', 'bind_availabilities', payload
      onSpaceBoothBindAvailabilities: (_, item) ->
        @$emit 'change', item

      unbindAvailabilitiesFromSpaceTrigger: (availabilities) ->
        payload = { availability_ids: availabilities.map((a) => a.id) }
        @triggerResource 'space_booth', 'unbind_availabilities', payload
      onSpaceBoothUnbindAvailabilities: (_, item) ->
        @$refs.spaceAvailabilitiesTable?.clearSelection()
        @$emit 'change', item

      setCapacityTrigger: (availabilities, capacity) ->
        payload = { availability_ids: availabilities.map((a) => a.id), capacity }
        @triggerResource 'availabilities', 'set_capacity', payload
      onAvailabilitiesSetCapacity: (_, item) ->
        @fetchAvailabilities()
        @$emit 'change', item

      fetchAvailabilities: ->
        params = { quick_list: true }
        params.audience_creative_id = @creativeId if @creativeId
        @fetch 'availabilities', params

export default VueOptions.vue settings
